export const INFRASTRUCTURE_PAGE_SLUG = 'infrastructure';
